webpackJsonp([79],{

/***/ 1244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'list'
});

/***/ }),

/***/ 1388:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".alarm .search[data-v-316319fd]{display:-webkit-box;display:-ms-flexbox;display:flex}.alarm .search .search-btn[data-v-316319fd]{background-color:#29abe2!important;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.1);box-shadow:0 2px 5px 0 rgba(0,0,0,.1);color:#f4f4f4;height:38px;width:109px}.alarm .search input[data-v-316319fd]{background-color:#fff;-webkit-box-shadow:inset 0 2px 5px 0 rgba(0,0,0,.2);box-shadow:inset 0 2px 5px 0 rgba(0,0,0,.2);color:#85939e;height:40px;margin-right:11.8px;padding:0 5px;width:100%}.alarm .name[data-v-316319fd]{color:#2f302f;font-size:20px;font-stretch:normal;font-style:normal;font-weight:600;height:24px;letter-spacing:normal;line-height:normal;text-align:left;width:231px}.alarm .check-info[data-v-316319fd]{display:-webkit-box;display:-ms-flexbox;display:flex}.alarm .check-info .check-in[data-v-316319fd],.alarm .check-info .check-out[data-v-316319fd]{display:grid;height:40px;margin-right:28px;padding:5px;width:231px}.alarm .check-info .check-in input[data-v-316319fd],.alarm .check-info .check-out input[data-v-316319fd]{background-color:#fff;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.18);box-shadow:0 2px 4px 0 rgba(0,0,0,.18);color:#85939e;height:40px;padding:0 5px;width:231px}.alarm .observation textarea[data-v-316319fd]{background-color:#fff;-webkit-box-shadow:inset 0 2px 5px 0 rgba(0,0,0,.2);box-shadow:inset 0 2px 5px 0 rgba(0,0,0,.2);color:#85939e;height:195.1px;padding:5px;width:492px}.alarm .observation .observation-button[data-v-316319fd]{background:#29abe2;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.1);box-shadow:0 2px 5px 0 rgba(0,0,0,.1);color:#fff;display:block;height:38px;margin-left:5px;margin-top:24px;width:164px}.time-picker[data-v-316319fd]{border-left:1px solid #979797}.time-picker .alarm-time .btn-timer[data-v-316319fd]{background-color:#efefef;border:1px solid #b5b5b5;border-radius:100px}.time-picker .alarm-time .btn-timer[data-v-316319fd],.time-picker .alarm-time .btn-timer[data-v-316319fd]:focus{font-stretch:normal;font-style:normal;font-weight:600;height:23px;letter-spacing:normal;line-height:normal;text-align:center;width:45px}.time-picker .alarm-time .btn-timer[data-v-316319fd]:focus{background-color:#29abe2;border-radius:100px;-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.24);box-shadow:0 1px 4px 0 rgba(0,0,0,.24);color:#efefef;font-size:14px}.time-picker .watch[data-v-316319fd]{height:240px;width:240px}.time-picker .time[data-v-316319fd]{background:#fff;border-radius:35px;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.18);box-shadow:0 2px 4px 0 rgba(0,0,0,.18);font-size:40px;font-stretch:normal;font-style:normal;font-weight:700;height:63.7px;letter-spacing:normal;line-height:63.7px;margin:auto;text-align:center;width:182.8px}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/alarm/List.vue"],"names":[],"mappings":"AACA,gCACE,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,4CACI,mCAAqC,AACrC,8CAAmD,AAC3C,sCAA2C,AACnD,cAAe,AACf,YAAa,AACb,WAAa,CAChB,AACD,sCACI,sBAAwB,AACxB,oDAAyD,AACjD,4CAAiD,AACzD,cAAe,AACf,YAAa,AACb,oBAAqB,AACrB,cAAiB,AACjB,UAAY,CACf,AACD,8BACE,cAAe,AACf,eAAgB,AAChB,oBAAqB,AACrB,kBAAmB,AACnB,gBAAiB,AACjB,YAAa,AACb,sBAAuB,AACvB,mBAAoB,AACpB,gBAAiB,AACjB,WAAa,CACd,AACD,oCACE,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,6FACI,aAAc,AACd,YAAa,AACb,kBAAmB,AACnB,YAAa,AACb,WAAa,CAChB,AACD,yGACM,sBAAwB,AACxB,+CAAoD,AAC5C,uCAA4C,AACpD,cAAe,AACf,YAAa,AACb,cAAiB,AACjB,WAAa,CAClB,AACD,8CACE,sBAAwB,AACxB,oDAAyD,AACjD,4CAAiD,AACzD,cAAe,AACf,eAAgB,AAChB,YAAa,AACb,WAAa,CACd,AACD,yDACE,mBAAoB,AACpB,8CAAmD,AAC3C,sCAA2C,AACnD,WAAa,AACb,cAAe,AACf,YAAa,AACb,gBAAiB,AACjB,gBAAiB,AACjB,WAAa,CACd,AACD,8BACE,6BAA+B,CAChC,AACD,qDACI,yBAA0B,AAC1B,yBAA0B,AAC1B,mBAAqB,CASxB,AACD,gHATI,oBAAqB,AACrB,kBAAmB,AACnB,gBAAiB,AACjB,YAAa,AACb,sBAAuB,AACvB,mBAAoB,AACpB,kBAAmB,AACnB,UAAY,CAiBf,AAfD,2DACI,yBAA0B,AAC1B,oBAAqB,AACrB,+CAAoD,AAC5C,uCAA4C,AACpD,cAAe,AAEf,cAAgB,CAQnB,AACD,qCACI,aAAc,AACd,WAAa,CAChB,AACD,oCACI,gBAAkB,AAClB,mBAAoB,AACpB,+CAAoD,AAC5C,uCAA4C,AACpD,eAAgB,AAChB,oBAAqB,AACrB,kBAAmB,AACnB,gBAAkB,AAClB,cAAe,AACf,sBAAuB,AACvB,mBAAoB,AACpB,YAAa,AACb,kBAAmB,AACnB,aAAe,CAClB","file":"List.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.alarm .search[data-v-316319fd] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.alarm .search .search-btn[data-v-316319fd] {\n    background-color: #29abe2 !important;\n    -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);\n            box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);\n    color: #f4f4f4;\n    height: 38px;\n    width: 109px;\n}\n.alarm .search input[data-v-316319fd] {\n    background-color: white;\n    -webkit-box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, 0.2);\n            box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, 0.2);\n    color: #85939e;\n    height: 40px;\n    margin-right: 11.8px;\n    padding: 0px 5px;\n    width: 100%;\n}\n.alarm .name[data-v-316319fd] {\n  color: #2f302f;\n  font-size: 20px;\n  font-stretch: normal;\n  font-style: normal;\n  font-weight: 600;\n  height: 24px;\n  letter-spacing: normal;\n  line-height: normal;\n  text-align: left;\n  width: 231px;\n}\n.alarm .check-info[data-v-316319fd] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.alarm .check-info .check-in[data-v-316319fd], .alarm .check-info .check-out[data-v-316319fd] {\n    display: grid;\n    height: 40px;\n    margin-right: 28px;\n    padding: 5px;\n    width: 231px;\n}\n.alarm .check-info .check-in input[data-v-316319fd], .alarm .check-info .check-out input[data-v-316319fd] {\n      background-color: white;\n      -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);\n              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);\n      color: #85939e;\n      height: 40px;\n      padding: 0px 5px;\n      width: 231px;\n}\n.alarm .observation textarea[data-v-316319fd] {\n  background-color: white;\n  -webkit-box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, 0.2);\n          box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, 0.2);\n  color: #85939e;\n  height: 195.1px;\n  padding: 5px;\n  width: 492px;\n}\n.alarm .observation .observation-button[data-v-316319fd] {\n  background: #29abe2;\n  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);\n          box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);\n  color: white;\n  display: block;\n  height: 38px;\n  margin-left: 5px;\n  margin-top: 24px;\n  width: 164px;\n}\n.time-picker[data-v-316319fd] {\n  border-left: 1px solid #979797;\n}\n.time-picker .alarm-time .btn-timer[data-v-316319fd] {\n    background-color: #efefef;\n    border: 1px solid #b5b5b5;\n    border-radius: 100px;\n    font-stretch: normal;\n    font-style: normal;\n    font-weight: 600;\n    height: 23px;\n    letter-spacing: normal;\n    line-height: normal;\n    text-align: center;\n    width: 45px;\n}\n.time-picker .alarm-time .btn-timer[data-v-316319fd]:focus {\n    background-color: #29abe2;\n    border-radius: 100px;\n    -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.24);\n            box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.24);\n    color: #efefef;\n    height: 23px;\n    font-size: 14px;\n    font-stretch: normal;\n    font-style: normal;\n    font-weight: 600;\n    letter-spacing: normal;\n    line-height: normal;\n    text-align: center;\n    width: 45px;\n}\n.time-picker .watch[data-v-316319fd] {\n    height: 240px;\n    width: 240px;\n}\n.time-picker .time[data-v-316319fd] {\n    background: white;\n    border-radius: 35px;\n    -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);\n            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);\n    font-size: 40px;\n    font-stretch: normal;\n    font-style: normal;\n    font-weight: bold;\n    height: 63.7px;\n    letter-spacing: normal;\n    line-height: 63.7px;\n    margin: auto;\n    text-align: center;\n    width: 182.8px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1473:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1388);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("5023ca3a", content, true);

/***/ }),

/***/ 1612:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alarm"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-flex', {
    attrs: {
      "text-xs-left": "",
      "pl-3": ""
    }
  }, [_c('p', [_vm._v("Buscar")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "search pb-3"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Escriba su nombre o apellido / empresa"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "search-btn"
  }, [_vm._v("Buscar")])], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "text-xs-left": "",
      "md6": "",
      "mr-5": "",
      "xs12": ""
    }
  }, [_c('p', [_vm._v("Completa los datos")]), _vm._v(" "), _c('p', [_vm._v("Huésped")]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("Ariel Esteban Puga Ogalde")]), _vm._v(" "), _c('div', {
    staticClass: "check-info"
  }, [_c('div', {
    staticClass: "check-in"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Check in")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "check-out"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Check out")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "observation pl-2 mt-5"
  }, [_c('p', [_vm._v("Observacióon")]), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10",
      "placeholder": "Escribe alguna observación"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "observation-button"
  }, [_vm._v("Guardar")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "row": "",
      "wrap": "",
      "md5": "",
      "xs12": "",
      "pt-5": ""
    }
  }, [_c('div', {
    staticClass: "time-picker"
  }, [_c('div', {
    staticClass: "alarm-time"
  }, [_c('span', {
    staticClass: "pr-3"
  }, [_vm._v("Hora de la llamada")]), _vm._v(" "), _c('button', {
    staticClass: "btn-timer"
  }, [_vm._v("a.m.")]), _vm._v(" "), _c('button', {
    staticClass: "btn-timer"
  }, [_vm._v("p.m.")])]), _vm._v(" "), _c('div', {
    staticClass: "watch"
  }), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('span', [_vm._v("1:13 A.M.")])])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 793:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1473)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1244),
  /* template */
  __webpack_require__(1612),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-316319fd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/79.8928c183e5693574191c.js